import React, { useState, useEffect } from "react"
import * as layouts from "layouts"
import * as caching from "brandguide/cache"
import * as brandguide from "brandguide"
import * as logos from "brandguide/build/logos"

interface props extends layouts.containers.ContainerProps {
	onChange(step: number, data: brandguide.api.GuideLogos | undefined): void
}

export function Display(props: props): JSX.Element {
	const { onChange, ...rest } = props
	const _guide = caching.useGuide()

	const [data, setData] = useState(brandguide.api.zeros.guide.guideLogosZero(_guide.guide?.logos))

	const svg = data.primary!.svg

	useEffect(() => {
		if ((_guide.guide?.logos?.misuse || []).length > 0) return
		setData({ ...data, misuse: brandguide.build.generators.initial.logos.misuse(svg) })
	}, [])

	const items = data.misuse || []

	return (
		<layouts.Flex {...rest}>
			<layouts.Flex
				flex="1"
				flexDirection="row"
				background={layouts.theme.colors.white}
				border={layouts.theme.borders.grey.dark50alpha}
				boxShadow={layouts.theme.boxshadow.black.wide}
			>
				<layouts.Flex flex="1" flexDirection="column" py="40px" className="panel">
					<brandguide.build.layouts.SectionStepTitle title="Logo Misuse" />
					<layouts.Flex flex="1">
						<brandguide.build.layouts.SectionStepContainer desc="Please remove the misuse that you do not approve of. These rules will apply to all logo variations.">
							<layouts.overlays.Container flexDirection="column" overflow="auto" height="42vh" my="10px">
								<layouts.containers.grid
									gap="15px"
									gridTemplateColumns="repeat(3, minmax(250px, 1fr))"
									gridTemplateRows="repeat(auto-fit, minmax(120px, 1fr))"
									style={{ alignContent: "start", alignItems: "start" }}
									minHeight="0px"
								>
									{items.map((item) => (
										<logos.layouts.MisUseItem
											key={item.title}
											item={item}
											onDelete={(upd) => {
												if (data.misuse.length === 1) {
													console.error("can't delete last one")
													return
												}
												setData({ ...data, misuse: items.filter((i) => i !== upd) })
											}}
										/>
									))}
								</layouts.containers.grid>
							</layouts.overlays.Container>

							<logos.Explanation
								val={data.descriptions?.misuse || ""}
								placeholder="Add further explanation of logo usage here."
								onChange={(text) => {
									setData({
										...data,
										descriptions: brandguide.api.zeros.logos.descZero({ ...data.descriptions, misuse: text }),
									})
								}}
							/>
							<brandguide.build.layouts.TwoWayStepsNav
								onBack={() => onChange(logos.Steps.PLACEMENT, undefined)}
								onNext={() => onChange(logos.Steps.USAGE, data)}
								disabled={!brandguide.validations.logos.valid.misuse(data)}
							/>
							<logos.Progress activeStep={logos.Steps.MISUSE} steps={logos.layouts.steps} />
						</brandguide.build.layouts.SectionStepContainer>
						<logos.Guidelines activPage="logos" />
					</layouts.Flex>
				</layouts.Flex>
			</layouts.Flex>
		</layouts.Flex>
	)
}

Display.defaultProps = {
	flex: "1",
}

export default Display
